import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=63a1a4f8&scoped=true"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"
import style0 from "./columns.vue?vue&type=style&index=0&id=63a1a4f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1a4f8",
  null
  
)

export default component.exports